import React from "react";
// import shape from "../../assets/images/shapes/welcome-one-shape-1.png"
import { IWelcomeData } from "../../exports/interfaces";
import { Fade } from "react-awesome-reveal";

const Welcome = (props: { welcomeData: IWelcomeData[] }) => {
  return (
    // <section className="about-one">
    //   <div className="container">
    //     <div className="row">
    //       <div className="col-xl-6">
    //         <div className="about-one__left">
    //           <div
    //             className="about-one__img wow slideInLeft"
    //             data-wow-delay="100ms"
    //             data-wow-duration="2500ms"
    //           >
    //             <img
    //               src={`${process.env.REACT_APP_strapiUrl}${props?.welcomeData[0]?.attributes?.Image?.data?.attributes?.url}`}
    //               alt=""
    //             />
    //             <div className="about-one__badge">
    //               <img
    //                 src={`${process.env.REACT_APP_strapiUrl}${props?.welcomeData[0]?.attributes?.Icon?.data?.attributes?.url}`}
    //                 alt=""
    //               />
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //       <div className="col-xl-6">
    //         <div className="about-one__right">
    //           <div className="about-one-shape float-bob-y">
    //             <img src="assets/images/shapes/about-one-shape.png" alt="" />
    //           </div>
    //           <div className="section-title text-left">
    //             <span className="section-title__tagline">
    //               {props?.welcomeData[0]?.attributes?.Welcome_Title}
    //             </span>
    //             <h2 className="section-title__title">
    //               {props?.welcomeData[0]?.attributes?.Title}
    //             </h2>
    //           </div>
    //           <p className="about-one__text" style={{ textAlign: "justify" }}>
    //             {props?.welcomeData[0]?.attributes?.Description}
    //           </p>

    //           <div className="fundraishing__btn-box custom-fundraishing__btn-box">
    //             <a href="donate-now.html" className="thm-btn fundraishing__btn">
    //               Know More
    //             </a>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </section>
    <section className="welcome-one">
      <div className="container">
        <div className="row">
          <div className="col-xl-6">
            <div className="welcome-one__left">
              <Fade cascade damping={0.2} direction="left" triggerOnce={true}>
                <div
                  className="welcome-one__img-box wow slideInLeft"
                  data-wow-delay="100ms"
                  data-wow-duration="2500ms"
                >
                  <div className="welcome-one__img">
                    <img
                      src={`${process.env.REACT_APP_strapiUrl}${props?.welcomeData[0]?.attributes?.Image?.data?.attributes?.url}`}
                      alt="welcome-image"
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "498px",
                      }}
                    />
                  </div>
                  <div className="welcome-one__small-img">
                    <img
                      src={`${process.env.REACT_APP_strapiUrl}${props?.welcomeData[0]?.attributes?.Small_Image?.data?.attributes?.url}`}
                      alt="welcome-image-small"
                      style={{
                        objectFit: "cover",
                        width: "251px",
                        height: "251px",
                      }}
                    />
                  </div>
                  {/* <div className="welcome-one-shape-1">
                                    <img src={shape} alt="shape" />
                                </div> */}
                </div>
              </Fade>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="welcome-one__right">
              <div className="section-title text-left">
                <span className="section-title__tagline">
                  {props?.welcomeData[0]?.attributes?.Welcome_Title}
                </span>
                <h2 className="section-title__title">
                  {props?.welcomeData[0]?.attributes?.Title}
                </h2>
              </div>
              {/* <p className="welcome-one__text-1">Pifoxen is the largest global crowdfunding.</p> */}
              <p
                className="welcome-one__text-2"
                style={{ textAlign: "justify" }}
              >
                {props?.welcomeData[0]?.attributes?.Description}
              </p>
              <div className="welcome-one__btn-box">
                <a href="/about" className="thm-btn welcome-one__btn">
                  Know More
                </a>
                {/* <div className="welcome-one__video-link">
                                    <a href="https://www.youtube.com/watch?v=Get7rqXYrbQ" className="video-popup">
                                        <div className="welcome-one__video-icon">
                                            <span className="fas fa-play"></span>
                                        </div>
                                    </a>
                                    <h4 className="welcome-one__video-text">Watch Video</h4>
                                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome;
